import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=f9230f8c&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=js&"
export * from "./FaqItem.vue?vue&type=script&lang=js&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=f9230f8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9230f8c",
  null
  
)

export default component.exports